// extracted by mini-css-extract-plugin
export default {"categoryField":"VendorUpdateModal_categoryField__rwL4V","chevron":"VendorUpdateModal_chevron__RbCHo"};